import { createAction, props } from '@ngrx/store';
import { ReminderDeliveryModel } from '@shared/data-access/models';

export const getDetail = createAction('[Payment Reminder Delivery] GET DETAIL', props<{ item: ReminderDeliveryModel }>());
